import script from "./AppSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppSection.vue?vue&type=script&setup=true&lang=ts"

import "./AppSection.vue?vue&type=style&index=0&id=7b80c797&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b80c797"]])

export default __exports__